export const renderProfession = (code) => {
  switch (code) {
  case 'RDH':
    return 'Dental Hygienist';

  case 'DA':
    return 'Dental Assistant';

  case 'DN':
    return 'Associate Dentist';
  default:
    return '';
  }
};
